import React from "react";
import { Box, HStack, Text, Divider } from "@chakra-ui/react";
import { TimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { ChevronUpIcon, ChevronDownIcon } from "@chakra-ui/icons";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

interface KYDTimePickerProps {
  label?: string;
  value?: dayjs.Dayjs | null;
  onChange?: (date: dayjs.Dayjs | null) => void;
  isDisabled?: boolean;
  timezone?: string;
}

dayjs.extend(utc);
dayjs.extend(timezone);

const KYDTimePicker = ({
  label,
  value,
  onChange,
  isDisabled = false,
}: KYDTimePickerProps) => {
  return (
    <HStack
      height="43px"
      boxShadow="0px 0px 10px 0px #0000000D"
      border="1px solid #E6E6E6"
      borderRadius="8px"
      px={3}
      py={1}
      alignItems="center"
    >
      <Text fontSize="14px" fontWeight="500" color="#000000B2">
        {label}
      </Text>
      <Divider orientation="vertical" borderColor="#E6E6E6" />
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <TimePicker
          value={value}
          disabled={isDisabled}
          onChange={onChange}
          sx={{
            border: "none",
            "& fieldset": { border: "none" },
            width: "100px",
            padding: "0",
            "& .MuiInputBase-root": { padding: "0" },
            "& .MuiInputBase-input": {
              padding: "0",
              fontSize: "14px",
              color: "#000000B2",
              fontFamily: "Work Sans",
            },
          }}
          slots={{
            openPickerIcon: () => (
              <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                lineHeight="0"
                padding="0"
              >
                <Box as="span" fontSize="12px" padding="0" margin="0">
                  <ChevronUpIcon />
                </Box>
                <Box as="span" fontSize="12px" padding="0" margin="0">
                  <ChevronDownIcon />
                </Box>
              </Box>
            ),
          }}
        />
      </LocalizationProvider>
    </HStack>
  );
};

export default KYDTimePicker;
